/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { roundDependencies } from './dependenciesRound.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCeil } from '../../factoriesAny.js';
export var ceilDependencies = {
  roundDependencies: roundDependencies,
  typedDependencies: typedDependencies,
  createCeil: createCeil
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCeil.generated.js
// module id = 619
// module chunks = 0